<template>
  <div class="sso">
    <div class="header">
      <img
        style='width: 260px;'
        src="@/assets/img/new-sso-logo.svg"
        alt="">
    </div>
    <div class="contentBody">
      <div class="contentBox">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Success',
  data () {
    return {
      formLabelAlign: {
        name: '',
        region: '',
        type: ''
      }
    }
  },
  created () {
    // this.downloadJSAtOnload();

  },
  mounted () {

  },
  methods: {
    routerPush (path) {
      ga('send', 'event', 'newUserService-ssoConfig-back', 'click')
      this.$store.commit('changeShowConfig', false)
      this.$router.push(path)
    }
  },
  beforeDestroy () {

  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('changeShowConfig', true)
    })
  }
}
</script>
